import {Star} from 'lucide-react'
import { isOfficialPenguinPadAccount } from '@/lib/colonyOfficial'

export default function ColonyOfficialStar({
  wallet,
  size = 'md',
}: {
  wallet?: string
  size?: 'sm' | 'md' | 'lg'
}) {
  if (!isOfficialPenguinPadAccount(wallet))
    return null

  const dim = size === 'lg' ? 'h-6 w-6' : size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'

  return (
    <Star
      className={`${dim} shrink-0 fill-lime-400 text-lime-400`}
      aria-label="Official Penguin Pad account"
      title="Official Penguin Pad account"
    />
  )
}
